<template>
	<v-dialog :value="value" max-width="620" persistent @input="$emit('input', $event)">
		<v-card v-if="item">
			<v-card-title class="text-h6">Aggiusta prezzo</v-card-title>
			<v-card-subtitle class="pt-1">{{ item.title || item.sellerSku }}</v-card-subtitle>
			<v-card-text>
				<v-simple-table dense class="mb-4">
					<thead>
						<tr>
							<th></th>
							<th class="text-right">Prezzo</th>
							<th class="text-right">Spedizione</th>
							<th class="text-right">Totale cliente</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Buybox ({{ analysis.isOurs ? 'nostra' : 'di altri' }})</td>
							<td class="text-right">{{ money(analysis.buyBoxListingPrice, currency) }}</td>
							<td class="text-right">{{ money(analysis.buyBoxShipping || 0, currency) }}</td>
							<td class="text-right font-weight-bold">{{ money(analysis.buyBoxLandedPrice, currency) }}</td>
						</tr>
						<tr>
							<td>Noi, oggi</td>
							<td class="text-right">{{ money(item.price, currency) }}</td>
							<td class="text-right">{{ shipping === null ? 'n.d.' : money(shipping, currency) }}</td>
							<td class="text-right" :class="{ 'red--text font-weight-bold': moreExpensive }">{{ money(currentTotal, currency) }}</td>
						</tr>
						<tr>
							<td>Noi, con il nuovo prezzo</td>
							<td class="text-right">{{ valid ? money(Number(price), currency) : '-' }}</td>
							<td class="text-right">{{ shipping === null ? 'n.d.' : money(shipping, currency) }}</td>
							<td class="text-right font-weight-bold">{{ money(newTotal, currency) }}</td>
						</tr>
					</tbody>
				</v-simple-table>

				<v-text-field hide-details="auto"
					v-model="price"
					label="Nuovo prezzo (senza spedizione)"
					type="number"
					step="0.01"
					min="0.01"
					:suffix="currency"
					outlined
					dense
					:rules="[rules.positive]"
					:hint="hint"
					persistent-hint
				></v-text-field>

				<v-alert v-if="noSuggestion" type="warning" text dense class="mt-4 mb-0">
					Con la nostra spedizione ({{ money(shipping, currency) }}) non c'è un prezzo positivo che batta il totale della buybox: valuta tu se e come intervenire.
				</v-alert>
				<v-alert v-if="shipping === null" type="info" text dense class="mt-4 mb-0">
					La nostra spedizione non è nota (rilancia l'analisi): il confronto è sui soli prezzi, senza spedizione.
				</v-alert>
				<v-alert type="info" text dense class="mt-2 mb-0">
					Il prezzo viene inviato subito ad Amazon (come "Modifica su cms/marketplace") e salvato da noi solo se Amazon lo accetta. Sul sito può comparire dopo qualche minuto.
				</v-alert>
				<v-alert v-if="!item._item" type="warning" text dense class="mt-2 mb-0">
					Pubblicazione non associata a un nostro prodotto: il prezzo cambia solo su Amazon.
				</v-alert>
				<v-alert v-if="error" type="error" text dense class="mt-2 mb-0">{{ error }}</v-alert>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text :disabled="saving" @click="$emit('input', false)">Annulla</v-btn>
				<v-btn color="primary" :loading="saving" :disabled="!valid" @click="confirm">Conferma</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { ourShipping, ourTotal, isMoreExpensive, suggestedPrice } from './pricing';

// Conferma del nuovo prezzo: il salvataggio lo fa il contenitore, qui solo il valore.
export default {
	name: 'AdjustPriceDialog',
	props: {
		value: { type: Boolean, default: false },
		item: { type: Object, default: null },
		saving: { type: Boolean, default: false },
		error: { type: String, default: '' },
	},
	data() {
		return {
			price: '',
			rules: {
				positive: v => Number(v) > 0 || 'Inserisci un prezzo maggiore di zero',
			},
		};
	},
	computed: {
		analysis() {
			return (this.item && this.item.analysis) || {};
		},
		currency() {
			return (this.item && this.item.currency) || this.analysis.currency || '';
		},
		shipping() {
			return ourShipping(this.item);
		},
		currentTotal() {
			return ourTotal(this.item);
		},
		moreExpensive() {
			return isMoreExpensive(this.item);
		},
		newTotal() {
			if (!this.valid || this.shipping === null) {
				return null;
			}
			return Math.round((Number(this.price) + this.shipping) * 100) / 100;
		},
		noSuggestion() {
			return this.shipping !== null && suggestedPrice(this.item) === null;
		},
		hint() {
			return this.shipping === null ? 'Proposto: un centesimo sotto il prezzo della buybox.' : 'Proposto: totale buybox meno la nostra spedizione, meno un centesimo. Puoi modificarlo.';
		},
		valid() {
			return Number(this.price) > 0;
		},
	},
	watch: {
		value(open) {
			if (open) {
				this.price = this.suggested();
			}
		},
	},
	methods: {
		money(value, currency) {
			if (value === null || value === undefined) {
				return '-';
			}
			return `${Number(value).toFixed(2)} ${currency || ''}`.trim();
		},
		suggested() {
			const value = suggestedPrice(this.item);
			return value === null ? '' : value.toFixed(2);
		},
		confirm() {
			if (!this.valid) {
				return;
			}
			this.$emit('confirm', Math.round(Number(this.price) * 100) / 100);
		},
	},
};
</script>
